module.exports = __webpack_public_path__ + "static/crossing_static-e98c0366bf269e4a9da356e94ff7dabe.png";